import React, { useState } from "react";
import { Button } from "antd";
import "./view.scss";

const filters = [
  { label: "すべて", key: "all" },
  { label: "共通", key: "common" },
  { label: "事業所所属", key: "office" },
  { label: "マイプレイリスト", key: "playlist" },
  { label: "最近アップロードされた動画", key: "recent" },
];

const TabVideo = ({tabs,activeKey,setActiveKey}) => {

  return (
    <div className="video-filter-tabs">
      {tabs.map((filter) => (
        <div
          key={filter.key}
          className={`video-filter-tab ${activeKey === filter.key ? "active" : ""}`}
          onClick={() => setActiveKey(filter)}
        >
          {filter.label}
        </div>
      ))}
    </div>
  );
};

export default TabVideo;